import { AppConfig } from '../../../../tt-lib/src/lib/interfaces/app-config';
/*
*
*  tmv
*
*/
export const appconfig: AppConfig = {
  app: 'tmv',
  langs: {
    'en': 'English',
    'de': 'Deutsch',
    'fr': 'Français',
    'nl': 'Nederlands'
  },
  map:
  {
    projection: 'EPSG:3812',
    layersPath: 'assets/JSON/',
    view: {
      zoomlevel: 1,
      center: [660666, 606690],
      // extent: [-682000, -150000, 2000000, 1310640]
      // extent: [-1100000, -250000, 3200000, 2100000]
      // extent: [-300000, 50000, 1600000, 1250000]
      //extent: [0, 160000, 1350000, 1100000]
      //extent: [100, 250000, 1300000, 1060000]
      extent: [-2550000, -1750000, 3500000, 3000000],
    },
    baselayers: {
      voidLayer: false,
      //list: ['cartoweb', 'classic.maps', 'orthophotos']
      //list: [ 'top10map',  'top50map', 'landcover100map' ]
      //list: [ 'ferraris', 'topo25_1873', 'topo25_1904','topo25_1939','topo25_1969', 'topo25_1981', 'topo25_1989','crossborder.topo', 'crossborder.topo_bw',  'ngi.cartoweb.topo.be', 'ngi.cartoweb.topo_bw.be', 'overlay.ortho', 'classic.maps','top10map', 'top25map',  'top50map', 'landcover100map', 'top250map', 'ngi.ortho', 'ortho.overlay']
      list: [ 'crossborder.topo', 'crossborder.topo_bw',  'ngi.cartoweb.topo.be', 'ngi.cartoweb.topo_bw.be', 'overlay.ortho', 'classic.maps','top10map', 'top25map',  'top50map', 'landcover100map', 'top250map', 'ngi.ortho', 'ortho.overlay']
      // list: [ 'crossborder.topo', 'ngi.cartoweb.topo.be', 'ngi.cartoweb.topo_bw.be', 'mapindex', 'classic.maps','top10map', 'top25map',  'top50map', 'landcover100map', 'top250map', 'ngi.ortho', 'ortho.overlay']
      //list: [ 'crossborder.topo', 'ngi.cartoweb.topo.be', 'ngi.cartoweb.topo_bw.be', 'overlay.ortho', 'top25map_beta',  'classic.maps','top10map', 'top25map',  'top50map', 'landcover100map', 'top250map', 'ngi.ortho', 'ortho.overlay']
      // list: ['ngi.ortho', 'ngi.cartoweb.topo_bw.be', 'ngi.cartoweb.topo.be']
    },
    overlays: {
      // defaultColor: [44, 60, 86, 1.0],
      defaultColor: [6, 138, 155, 1.0],
      highlightColor: [234, 89, 1, 1.0]
    },

    controls: {
      zoomToExtent: {
        zoomAllBtn: true,
        extent: [486993, 486740, 832616, 759401]
      },
      scaleLine: {
        addScaleLine: true,
        units: 'metric',
        steps: 2
      },
      mousePosition: {
        addMousePosition: true,
        mouseProjections: [
          { epsg: 'EPSG:3812', precision: 2, format: 'XY', name: 'Lambert08' },
          { epsg: 'EPSG:31370', precision: 2, format: 'XY', name: 'Lambert72' },
          { epsg: 'EPSG:4258', precision: 6, format: 'XY', name: 'ETRS89' },
          { epsg: 'EPSG:32631', precision: 2, format: 'XY', name: 'UTM' },
        ],
         sheetsInMouseProjection: true
      },
      geolocation: true,
    }
  }
}